<template>
  <div class="space-y-5 card-auto mt-6">
    <Card>
      <div
          class="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 grid-cols-1 gap-5 place-content-center"
      >
        <div class="flex space-x-4 h-full items-center rtl:space-x-reverse">
          <div class="flex-none">
            <div class="h-20 w-20 rounded-full">
              <img
                  src="@/assets/images/all-img/main-user.png"
                  alt=""
                  class="w-full h-full"
              />
            </div>
          </div>
          <div class="flex-1">
            <h4 class="text-xl font-medium mb-2">
              <span class="block font-light">Good evening,</span>
              <span class="block">{{ userStore.getName }}</span>
            </h4>
            <!--            <p class="text-sm dark:text-slate-300">Welcome to {{ config.siteName }}</p>-->
          </div>
        </div>

        <div
            v-for="(item, i) in statistics2"
            :key="i"
            class="bg-slate-50 dark:bg-slate-900 rounded p-4"
        >
          <div class="flex space-x-3 rtl:space-x-reverse">
            <div class="flex-none">
              <div
                  class="h-12 w-12 rounded-full flex flex-col items-center justify-center text-2xl"
                  :class="`${item.bg} ${item.text}`"
              >
                <Icon :icon="item.icon"/>
              </div>
            </div>
            <div class="flex-1">
              <div
                  class="text-slate-600 dark:text-slate-300 text-sm mb-1 font-medium"
              >
                {{ item.title }}
              </div>
              <div
                  class="text-slate-900 dark:text-white text-lg font-medium"
              >
                {{ item.count }}
              </div>
            </div>
          </div>
        </div>

      </div>
    </Card>
    <transactions :_transactions="transactions" @addedTransaction="getTransactions"/>
  </div>
</template>

<script>
import transactions from "@/views/profile/transactions.vue";
import Card from "@/components/Card/index.vue";
import {config} from "@/config.js"
import Icon from "@/components/Icon/index.vue";
import {useUserStore} from "@/stores/user";
import {useTransactionStore} from "@/stores/transaction";
import {computed, ref} from "vue";

export default {
  name: "financial",
  components: {
    transactions,
    Card,
    Icon,
  },
  setup() {
    const userStore = useUserStore();
    const transactionStore = useTransactionStore();
    const transactions = ref([]);
    const statistics2 = computed(() => [
      {
        title: "Current Balance",
        count: userStore.getProfileAttribute('balance') ?? 0,
        bg: "bg-[#E5F9FF] dark:bg-slate-700",
        text: "text-success-500",
        icon: "simple-line-icons:wallet",
      },
      {
        title: "Pending",
        count: "-",
        bg: "bg-[#FFEDE6] dark:bg-slate-700",
        text: "text-warning-400",
        icon: "ic:round-block",
      },
    ]);

    async function getTransactions() {
      await transactionStore.action_getTransactions()
      transactions.value = transactionStore.getTransactions;
    }

    getTransactions()
    return {
      config,
      transactions,
      getTransactions,
      userStore,
      statistics2
    }
  }
}
</script>

<style scoped>

</style>
